import { setTimeout } from "timers";

export function accordionEvents() {
	$(window).on("load", function () {
		$('.accordion a.btn').on('click', function (e) {
			e.preventDefault();
			var clickedElem = $(this);
			setTimeout(function () {
				$('html,body').animate({ scrollTop: $(clickedElem).offset().top - 50 }, 'slow');
			}, 300);

		})
	})
}